import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ObjectUtils } from "src/app/utils/ObjectUtils";
import { environment } from "src/environments/environment";
import { AccountCreateDTO } from "../../schema/Billing/Account/AccountCreateDTO";
import { AccountDTO } from "../../schema/Billing/Account/AccountDTO";
import { AccountUpdateDTO } from "../../schema/Billing/Account/AccountUpdateDTO";
import { AffiliatesFilterDTO } from "../../schema/Billing/Filter/AffiliatesFilterDTO";
import { GetDataDTO } from "../../schema/Common/GetDataDTO";

@Injectable({
    providedIn: "root"
})
export class ApiAccountService {
    private relativePath: string;

    constructor(private http: HttpClient) {
        // Corrigido para apontar para Accounts
        this.relativePath = `${environment.billing.url}/api/v1/Accounts`;
    }

    public list(filterAccounts: AffiliatesFilterDTO): Observable<GetDataDTO<AccountDTO>> {
        const httpParams = new HttpParams({
            fromObject: ObjectUtils.removeNullUndefinedFields(filterAccounts)
        });

        return this.http.get<GetDataDTO<AccountDTO>>(`${this.relativePath}`, {
            params: httpParams
        });
    }

    public create(account: AccountCreateDTO): Observable<AccountDTO> {
        return this.http.post<AccountDTO>(`${this.relativePath}`, account);
    }

    public update(id: string, account: AccountUpdateDTO): Observable<AccountDTO> {
        return this.http.put<AccountDTO>(`${this.relativePath}/${id}`, account);
    }

    public getMain(subscriptionId?: string): Observable<AccountDTO> {
        const params = subscriptionId ? { subscriptionId } : {};
        return this.http.get<AccountDTO>(`${this.relativePath}/main`, { params });
    }

    public getById(id: string, subscriptionId?: string): Observable<AccountDTO> {
        const params = subscriptionId ? { subscriptionId } : {};
        return this.http.get<AccountDTO>(`${this.relativePath}/${id}`, { params });
    }
}
